/**
 * @generated SignedSource<<7a322c73cf1e040d27ee73bac6f907af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
export type ValidateIntegrationInput = {
  credentials: string;
  integrationId?: any | null | undefined;
  integrationType: IntegrationType;
};
export type PGAnalyzeIntegrationFormValidateIntegrationMutation$variables = {
  input: ValidateIntegrationInput;
};
export type PGAnalyzeIntegrationFormValidateIntegrationMutation$data = {
  readonly validateIntegration: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type PGAnalyzeIntegrationFormValidateIntegrationMutation = {
  response: PGAnalyzeIntegrationFormValidateIntegrationMutation$data;
  variables: PGAnalyzeIntegrationFormValidateIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ValidateIntegrationPayload",
    "kind": "LinkedField",
    "name": "validateIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAnalyzeIntegrationFormValidateIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAnalyzeIntegrationFormValidateIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "96f00b8817679112fd871474aa6b534b",
    "id": null,
    "metadata": {},
    "name": "PGAnalyzeIntegrationFormValidateIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation PGAnalyzeIntegrationFormValidateIntegrationMutation(\n  $input: ValidateIntegrationInput!\n) {\n  validateIntegration(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "a77fddfd4c75c2d70e3b0945f0efba9c";

export default node;
